import { ModalDialog } from 'vetrf-ui';

type RemoveMotionModalProps = {
  onClose: () => void;
  onRemove: () => void;
};

export const RemoveMotionModal = ({ onClose, onRemove }: RemoveMotionModalProps) => (
  <ModalDialog
    header="Подтверждение"
    onClose={onClose}
    confirmBtn={{
      action: onRemove,
      text: 'Удалить',
      color: 'danger',
      size: 'sm',
    }}
    cancelBtn={{
      text: 'Отмена',
      size: 'sm',
    }}
  >
    Вы уверены, что хотите удалить движение заявки?
  </ModalDialog>
);
